import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-92f4bd5a")

_pushScopeId("data-v-92f4bd5a")
const _hoisted_1 = {
  class: "tickets-done",
  id: "tickets-done"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "i-task"
}
const _hoisted_4 = {
  key: 1,
  class: "i-working"
}
const _hoisted_5 = {
  key: 2,
  class: "i-aftersale"
}
const _hoisted_6 = {
  key: 3,
  class: "i-test"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "pagination-wrap"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TicketViewSearchForm = _resolveComponent("TicketViewSearchForm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TicketViewSearchForm, {
      queryForm: _ctx.savedQueryData,
      submit: _ctx.ticketViewSearchFormSubmit
    }, null, 8, ["queryForm", "submit"]),
    _withDirectives(_createVNode(_component_el_table, {
      border: "",
      class: "ticket-table",
      data: _ctx.tableData,
      style: {"width":"100%"},
      "default-sort": _ctx.orderField,
      onSortChange: _ctx.sortChange
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          width: "80",
          label: "编号",
          sortable: "custom"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.goBlankRouter(scope))
            }, _toDisplayString(scope.row.id), 9, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题",
          "show-overflow-tooltip": "",
          width: "180"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.goBlankRouter(scope)),
              class: "ticket-title"
            }, [
              _createVNode("span", _hoisted_2, [
                (scope.row.sourceType === 'task')
                  ? (_openBlock(), _createBlock("i", _hoisted_3))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'warning')
                  ? (_openBlock(), _createBlock("i", _hoisted_4))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'after_sale')
                  ? (_openBlock(), _createBlock("i", _hoisted_5))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'test')
                  ? (_openBlock(), _createBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(scope.row.title), 1)
              ])
            ], 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        }, {
          default: _withId((scope) => [
            (scope.row.desc)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withId(() => [
                    _createVNode("div", {
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  default: _withId(() => [
                    _createVNode("div", {
                      class: "ticket-desc",
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "curPhase",
          width: "90",
          label: "阶段",
          sortable: "custom"
        }, {
          default: _withId(({ row }) => [
            (row.curPhaseId)
              ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(row.curPhase), 1))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList((row.curPhases?.map(v => v.phaseName) || []), (v, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, _toDisplayString(v), 1))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "urgentLevel",
          width: "110",
          label: "紧急程度",
          sortable: "custom",
          formatter: _ctx.priorityFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "创建时间",
          sortable: "custom",
          width: "120",
          formatter: _ctx.createTimeFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "updatedAt",
          label: "更新时间",
          width: "120",
          formatter: _ctx.updatedTimeFormatter
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "default-sort", "onSortChange"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.total)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _ctx.pageSize,
            layout: "prev, pager, next, sizes, jumper, total",
            total: _ctx.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true)
  ]))
})